import { default as axiosDefault } from "axios";

import { normalizeEmptyString } from "@av/utils/normalize-empty-string";

export const browserNavigation = {
  navigate: (url: string) => {
    window.location.href = url;
  },
};

/**
 * bffAxios is the API Client for the entire frontend. Any endpoints referenced from the FE need to be explicitly defined in the bff.
 * Check app/node-server/docs/guide/add-bff-endpoint for mode detauls
 */
export const bffAxios = axiosDefault.create({
  baseURL: "/api",
});

bffAxios.interceptors.request.use((config) => {
  const method = (config.method ?? "").toLowerCase();

  //Reason: This is done to prevent sending empty strings to the db for optional values.
  //We should always be saving null instead to ensure easier debugging.
  if (["put", "post"].includes(method) && config.data) {
    config.data = normalizeEmptyString(config.data);
  }

  /**
   * TODO: Wire up locale from central location
   */
  config.headers["Accept-Language"] = "en-CA";

  return config;
});

bffAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const [product] = window.location.pathname.split("/").filter((i) => i);

    if (error.response && error.response.status === 404) {
      console.log("404 error caught. Redirecting to /not_found.");
      browserNavigation.navigate(`/${product}/not_found`);
    } else if (
      error.response &&
      error.response.status === 401 &&
      // A request that fails after logout has navigated to /login must not reload the page and drop the logged-out message.
      window.location.pathname !== "/login"
    ) {
      console.log("401 error caught. Redirecting to /login.");
      browserNavigation.navigate("/login");
    } else if (error.response && error.response.status === 403) {
      console.log("403 error caught. Redirecting to /forbidden.");
      browserNavigation.navigate(`/${product}/forbidden`);
    }

    return Promise.reject(error);
  }
);
